module.exports = __webpack_public_path__ + "img/LPTemp6.8056d194.png";